<div class="container">
  <div class="header">
    <h2>Atualizar informações</h2>
  </div>
  <div class="denounce-detail-local-content">
    <form [formGroup]="userEditForm" class="local-edit-form" (ngSubmit)="userEdit()">
      <div class="denounce-detail-content local">
        <div>
          <label class="content-title" for="name">Nome:</label>
          <input id="name" type="text" class="login-form-input form-control" placeholder="Nome" name="name"
            formControlName="name" />
        </div>
        <div>
          <label class="content-title" for="gender">Gênero:</label>
          <select class="form-control" ngModel required formControlName="gender">
            <option value="WOMAN_CIS">Mulher Cis</option>
            <option value="WOMAN_TRANS">Mulher Trans</option>
            <option value="MAN_CIS">Homem Cis</option>
            <option value="MAN_TRANS">Homem Trans</option>
            <option value="NON_BINARY">Não Binário</option>
          </select>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button mat-button (click)="onClose()">Cancelar</button>

    <button mat-button type="submit" [disabled]="!userEditForm.valid" (click)="userEdit()" color="primary">
      Salvar
    </button>
  </div>
</div>